//
//
//
//
//
//
//
//
//
//
//

import topHeader from '../../component/topHeader.vue'
import leftMenu from '../../component/leftMenu.vue'
import { mapGetters, mapState } from 'vuex'

export default {
    data() {
        return {
            userInfo: {}
        }
    },
    async created() {
        const infos = await this.$x.post('/api/getInfo')
        this.userInfo = infos
        this.$x.userInfo.setUserInfo(infos)
        await this.getMenus()
    },
    methods: {
        async getMenus() {
            const menus = await this.$x.post('/api/getMenus')
            this.$store.dispatch('setTopMenus', { topMenus: menus || [], vm: this });
        }
    },
    components: { topHeader, leftMenu },
    computed: {
        ...mapGetters(['leftMenus']),
        ...mapState(['topMenus', 'topMenuIndex'])
    }
}
